module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0079.jpg?v=ca6b5041";